import { createPluginFactory } from "@udecode/plate";

export const UNDO_PLUGIN = "undo";

export const createUndoPlugin = createPluginFactory({
  key: UNDO_PLUGIN,
  isVoid: true,
});
